import { useTranslation } from "react-i18next";
import { players } from "@/mocks/home";

const getInitials = (name: string) =>
  name
    .split(" ")
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

export default function Players() {
  const { t } = useTranslation();

  return (
    <section id="players" className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mb-10 md:mb-14">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-primary-400"></span>
            <span className="font-label text-sm uppercase tracking-[0.3em] text-primary-600">
              {t("players.kicker")}
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950">
            {t("players.title")}
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-600">
            {t("players.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {players.map((player, index) => (
            <div
              key={player.id}
              className="flex items-center gap-4 p-4 rounded-lg border border-background-200 bg-background-50 hover:border-primary-300 hover:bg-background-100/60 transition-colors"
            >
              <span
                className={`flex items-center justify-center w-12 h-12 rounded-full font-heading font-semibold text-sm shrink-0 ${
                  index % 3 === 1
                    ? "bg-accent-100 text-accent-800"
                    : index % 3 === 2
                      ? "bg-primary-100 text-primary-800"
                      : "bg-secondary-100 text-secondary-800"
                }`}
              >
                {getInitials(player.name)}
              </span>
              <span className="min-w-0">
                <span className="block font-heading text-base md:text-lg font-semibold text-foreground-950 truncate">
                  {player.name}
                </span>
                <span className="block font-label text-xs uppercase tracking-[0.16em] text-foreground-500">
                  {player.role}
                </span>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}